module.exports = __webpack_public_path__ + "img/race_1920.8756c91d.png";